<template>
<v-container fluid>
  <div class="page-shell">
    <v-card class="page-card">
      <v-tabs v-model="bottomNav" bg-color="primary" class="agrochemical-tabs" show-arrows>
        <v-tab v-if="can('agrochemicals.products.read')" value="stock">
          <v-icon start>reorder</v-icon>
          Stock
        </v-tab>
        <v-tab v-if="can('agrochemicals.withdrawals.read')" value="withdrawHistory">
          <v-icon start>history</v-icon>
          Retiros
        </v-tab>
        <v-tab v-if="can('agrochemicals.applications.read')" value="application">
          <v-icon start>terrain</v-icon>
          Aplicaciones
        </v-tab>
        <v-tab v-if="canAny(reportPermissions)" value="export">
          <v-icon start>assessment</v-icon>
          Reportes
        </v-tab>
      </v-tabs>
    </v-card>
    <dialog-form-agrochemical v-if="canAny(['agrochemicals.products.create', 'agrochemicals.products.update'])"/>
    <v-window v-model="bottomNav">
      <v-window-item v-if="can('agrochemicals.products.read')" value="stock">
        <table-agrochemical/>
      </v-window-item>
      <v-window-item v-if="can('agrochemicals.withdrawals.read')" value="withdrawHistory">
        <table-withdrawed-agrochemicals/>
      </v-window-item>
      <v-window-item v-if="can('agrochemicals.applications.read')" value="application">
        <table-application-agrochemicals/>
      </v-window-item>
      <v-window-item v-if="canAny(reportPermissions)" value="export">
        <export-agrochemical-panel/>
      </v-window-item>
    </v-window>
  </div>
</v-container>
</template>
<script>
import AddEditAgrochemicalForm from './AddEditAgrochemicalForm'
import AgrochemicalTable from './AgrochemicalTable'
import WithdrawAgrochemicalTable from './WithdrawAgrochemicalTable'
import ApplicationAgrochemicalTable from './ApplicationAgrochemicalTable'
import ExportAgrochemicalForm from './ExportAgrochemicalForm'

export default {
  name: 'Agrochemical',
  components: {
    'dialog-form-agrochemical': AddEditAgrochemicalForm,
    'table-agrochemical': AgrochemicalTable,
    'table-withdrawed-agrochemicals': WithdrawAgrochemicalTable,
    'table-application-agrochemicals': ApplicationAgrochemicalTable,
    'export-agrochemical-panel': ExportAgrochemicalForm
  },
  data () {
    return {
      bottomNav: null,
      reportPermissions: ['agrochemicals.reports.costs.export', 'agrochemicals.reports.stock.export', 'agrochemicals.reports.withdrawals.export']
    }
  },
  created () {
    const tabs = [
      ['stock', 'agrochemicals.products.read'],
      ['withdrawHistory', 'agrochemicals.withdrawals.read'],
      ['application', 'agrochemicals.applications.read']
    ]
    this.bottomNav = tabs.find(([, permission]) => this.can(permission))?.[0] || (this.canAny(this.reportPermissions) ? 'export' : null)
  },
  methods: {
    can (permission) { return this.$store.getters['authModule/hasPermission'](permission) },
    canAny (permissions) { return permissions.some(permission => this.can(permission)) }
  }
}
</script>
